"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

function _typeof(a) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (a) {
    return typeof a;
  } : function (a) {
    return a && "function" == typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
  }, _typeof(a);
}

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireDefault(require("react")),
    S = _interopRequireWildcard(require("./styles"));

function _getRequireWildcardCache() {
  if ("function" != typeof WeakMap) return null;
  var a = new WeakMap();
  return _getRequireWildcardCache = function _getRequireWildcardCache() {
    return a;
  }, a;
}

function _interopRequireWildcard(a) {
  if (a && a.__esModule) return a;
  if (null === a || "object" !== _typeof(a) && "function" != typeof a) return {
    "default": a
  };

  var b = _getRequireWildcardCache();

  if (b && b.has(a)) return b.get(a);
  var c = {},
      d = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var e in a) {
    if (Object.prototype.hasOwnProperty.call(a, e)) {
      var f = d ? Object.getOwnPropertyDescriptor(a, e) : null;
      f && (f.get || f.set) ? Object.defineProperty(c, e, f) : c[e] = a[e];
    }
  }

  return c["default"] = a, b && b.set(a, c), c;
}

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    "default": a
  };
}

var _default = function _default() {
  return _react["default"].createElement(S.IconLogoLight, {
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 291.69"
  }, _react["default"].createElement("defs", null, _react["default"].createElement("style", null, "  .cls-1{fill:none;}  .cls-2{clip-path:url(#clip-path);}  .cls-3{fill:#fff;}  .cls-4{fill:#eb008b;}  "), _react["default"].createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 0.69)"
  }, _react["default"].createElement("rect", {
    "class": "cls-1",
    y: "-0.69",
    width: "600",
    height: "291.69"
  }))), _react["default"].createElement("title", null, "godoo_logo_white"), _react["default"].createElement("g", {
    "class": "cls-2"
  }, _react["default"].createElement("path", {
    "class": "cls-3",
    d: "M484.42,80.23A26.45,26.45,0,1,1,458,53.88a26.4,26.4,0,0,1,26.45,26.35m25.27,0A51.71,51.71,0,1,0,458,131.77a51.62,51.62,0,0,0,51.71-51.54",
    transform: "translate(0 0.69)"
  }), _react["default"].createElement("path", {
    "class": "cls-4",
    d: "M266.75,83A51.71,51.71,0,1,0,215,134.55,51.62,51.62,0,0,0,266.75,83",
    transform: "translate(0 0.69)"
  }), _react["default"].createElement("path", {
    "class": "cls-3",
    d: "M574.73,80.23a26.45,26.45,0,1,1-26.45-26.35,26.4,26.4,0,0,1,26.45,26.35m25.27,0a51.71,51.71,0,1,0-51.71,51.54A51.62,51.62,0,0,0,600,80.23",
    transform: "translate(0 0.69)"
  }), _react["default"].createElement("path", {
    "class": "cls-4",
    d: "M128.81,130.39c5.54,10.14,5.09,16.27-3.39,26.3,11,3.64,9.36,2.79,13.7,4.49,3.85-4.34,20.22-20.65,1.57-42.63",
    transform: "translate(0 0.69)"
  })), _react["default"].createElement("rect", {
    "class": "cls-3",
    x: "92.68",
    y: "19.92",
    width: "63.39",
    height: "24.49"
  }), _react["default"].createElement("g", {
    "class": "cls-2"
  }, _react["default"].createElement("path", {
    "class": "cls-3",
    d: "M31.91,220c0,25.73,27.21,46.59,60.77,46.59s60.78-20.86,60.78-46.59-27.21-46.59-60.78-46.59S31.91,194.22,31.91,220M0,220c0-39.24,41.49-71,92.68-71s92.68,31.81,92.68,71S143.87,291,92.68,291,0,259.19,0,220",
    transform: "translate(0 0.69)"
  }), _react["default"].createElement("path", {
    "class": "cls-3",
    d: "M131.53,82.13A38.57,38.57,0,1,1,93,43.69a38.5,38.5,0,0,1,38.57,38.44m24.54,0A63.11,63.11,0,1,0,93,145a63,63,0,0,0,63.11-62.9",
    transform: "translate(0 0.69)"
  })), _react["default"].createElement("rect", {
    "class": "cls-3",
    x: "375.04",
    width: "24.48",
    height: "82.79"
  }), _react["default"].createElement("g", {
    "class": "cls-2"
  }, _react["default"].createElement("path", {
    "class": "cls-3",
    d: "M375.07,82.11a38.43,38.43,0,1,1-38.43-38.43,38.43,38.43,0,0,1,38.43,38.43m24.45,0A62.88,62.88,0,1,0,336.65,145a62.88,62.88,0,0,0,62.88-62.88",
    transform: "translate(0 0.69)"
  })));
};

exports["default"] = _default;